"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import s from "underscore.string";
import React from "react";
import _ from "underscore";
import Auth from "../util/auth";
import Api from "../api/api";
import classNames from "classnames";
import DisablingButton from "../components/disabling_button";
import DocumentThumbnail from "./document_thumbnail";
import EmailTypeAhead from "./email_typeahead";
import WaitingSpinner from "../components/waiting_spinner";
import BouncesMessage from "./bounces_message";
import LoadEmailCreator from "./load_email_creator";
var ExceptionSender = React.createClass({
  getDefaultProps: function() {
    return {
      multipleExceptionMessagesEnabled: false,
      customEmailTemplates: []
    };
  },
  getInitialState: function() {
    var _a, _b, _c;
    const sendNoteToPayeeDefault = this.showPaymentsNetworkExceptionSender();
    let recipients = ((_a = this.props.parent) == null ? void 0 : _a.sender_address) || "";
    const factoringCompany = this.props.factoringCompany;
    recipients = this.replaceNoReplyRecipientsWithPreferredRecipient(
      recipients,
      factoringCompany
    );
    const defaultCustomTemplateId = this.props.multipleExceptionMessagesEnabled && this.props.customEmailTemplates && this.props.customEmailTemplates.length > 0 ? (_c = (_b = this.props.customEmailTemplates.find((template) => template.is_default)) == null ? void 0 : _b.id) == null ? void 0 : _c.toString() : "";
    const exceptionEmail = this.getEmailFromTemplate(defaultCustomTemplateId, {
      selectedTemplate: "",
      subject: this.props.defaultEmail.subject,
      body: this.props.defaultEmail.body
    });
    return {
      selectedTemplate: exceptionEmail.selectedTemplate,
      subject: exceptionEmail.subject,
      body: exceptionEmail.body,
      recipients,
      sendEmail: !sendNoteToPayeeDefault,
      sendNoteToPayee: sendNoteToPayeeDefault
    };
  },
  componentWillReceiveProps: function(newProps) {
    if (this.props.factoringCompany !== newProps.factoringCompany && newProps.factoringCompany) {
      let recipients = this.state.recipients;
      const factoringCompany = newProps.factoringCompany;
      recipients = this.replaceNoReplyRecipientsWithPreferredRecipient(
        recipients,
        factoringCompany
      );
      this.setState({ recipients });
    }
  },
  replaceNoReplyRecipientsWithPreferredRecipient: function(recipients, factoringCompany) {
    if (factoringCompany && factoringCompany.settings) {
      const noReplyEmailAddresses = factoringCompany.settings.no_reply_email_addresses || [];
      const preferredReplyEmailAddress = factoringCompany.settings.preferred_reply_email_address;
      let recipientsList = recipients.split(", ");
      recipientsList = recipientsList.map((recipient) => {
        if (noReplyEmailAddresses.includes(recipient)) {
          return preferredReplyEmailAddress;
        } else {
          return recipient;
        }
      });
      recipients = recipientsList.join(", ");
    }
    return recipients;
  },
  documentToggled: function(doc) {
    var newState = {};
    newState[doc.id] = !this.state[doc.id];
    this.setState(newState);
  },
  enableDocuments: function() {
    var newState = {};
    _.each(this.props.documents, function(doc) {
      newState[doc.id] = false;
    });
    return newState;
  },
  setSendEmail: function() {
    this.setState({ sendEmail: true, sendNoteToPayee: false });
  },
  setPrivateNote: function() {
    this.setState({ sendEmail: false, sendNoteToPayee: false });
  },
  setSendNoteToPayee: function() {
    var newState = { sendNoteToPayee: true, sendEmail: false };
    newState = __spreadValues(__spreadValues({}, newState), this.enableDocuments());
    this.setState(newState);
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(WaitingSpinner, { "data-component": "ExceptionSender", when: this.state.saving }, /* @__PURE__ */ React.createElement("div", { className: "exception-sender" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, this.possibleNoteOrEmailSelection(), this.possibleSendEmail(), this.possiblePrivateNote(), this.possibleSendNoteToPayee())));
  },
  possibleNoteOrEmailSelection: function() {
    if (!this.props.messageSent && !this.props.ignored) {
      return /* @__PURE__ */ React.createElement("div", { className: "exception-sender__note-or-email-selection" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, this.possibleSendNoteToPayeeToggle()), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          id: "send-exception-email",
          type: "radio",
          checked: this.state.sendEmail,
          onChange: this.setSendEmail
        }
      ), /* @__PURE__ */ React.createElement("label", { htmlFor: "send-exception-email" }, this.showPaymentsNetworkExceptionSender() ? "Send an internal email" : "Send an email")), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          id: "save-without-emailing",
          type: "radio",
          checked: !this.state.sendEmail && !this.state.sendNoteToPayee,
          onChange: this.setPrivateNote
        }
      ), /* @__PURE__ */ React.createElement("label", { htmlFor: "save-without-emailing" }, "Save note and move to waiting without sending an email")));
    }
  },
  showPaymentsNetworkExceptionSender: function() {
    return this.props.carrierInvoice && this.props.carrierInvoice.is_payments_network_submission;
  },
  possibleSendNoteToPayeeToggle: function() {
    if (this.showPaymentsNetworkExceptionSender()) {
      const payee = this.props.carrierInvoice.payments_network_payee_name;
      const toggleTitle = "Send to " + payee + " through Payments Network";
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        "input",
        {
          id: "send-payments-network-email",
          type: "radio",
          checked: this.state.sendNoteToPayee,
          onChange: this.setSendNoteToPayee
        }
      ), /* @__PURE__ */ React.createElement("label", { htmlFor: "send-payments-network-email" }, toggleTitle));
    }
  },
  privateNoteFields: function() {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "small-6 column" }, /* @__PURE__ */ React.createElement("label", null, "Private Note"), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "text",
        value: this.state.note || "",
        onChange: (e) => this.setState({ note: e.target.value })
      }
    )), /* @__PURE__ */ React.createElement("div", { className: "small-4 column" }, /* @__PURE__ */ React.createElement("label", null, "Review On"), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "date",
        value: this.state.review_on || "",
        onChange: (e) => this.setState({ review_on: e.target.value })
      }
    )));
  },
  possibleSendEmail: function() {
    if (this.state.sendEmail) {
      const contacts = [
        ...this.props.contacts || [],
        ..._.get(this.props.possibleLoad, ["load", "contacts"], [])
      ];
      return /* @__PURE__ */ React.createElement("div", { className: "exception-sender__email" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement(BouncesMessage, { recipients: this.maybeGetRecipients() }), /* @__PURE__ */ React.createElement("label", null, "Recipients"), /* @__PURE__ */ React.createElement(
        EmailTypeAhead,
        {
          focusBehavior: "focus",
          onChange: this.recipientsChanged,
          selectByDefault: !this.noDefaultSenderEnabled(),
          recipients: this.maybeGetRecipients(),
          contacts
        }
      )), this.props.multipleExceptionMessagesEnabled && /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("label", null, "Template"), /* @__PURE__ */ React.createElement(
        "select",
        {
          value: this.state.selectedTemplate || "",
          onChange: this.templateChanged
        },
        this.renderTemplateOptions()
      )), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("label", null, "Subject"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          value: this.state.subject || "",
          onChange: (e) => this.setState({ subject: e.target.value })
        }
      )), this.privateNoteFields(), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("label", null, "Message"), /* @__PURE__ */ React.createElement(
        "textarea",
        {
          rows: 12,
          value: this.state.body || "",
          onChange: (e) => this.setState({ body: e.target.value })
        }
      )), this.possibleDocuments(), /* @__PURE__ */ React.createElement("div", { className: "small-10 column exception-sender__documents-wrapper" }, this.sendButton(), this.possibleCancel()));
    }
  },
  possiblePrivateNote: function() {
    if (this.props.hasMore) {
      var completionContext = "and go to next group";
    } else {
      var completionContext = "and return to dashboard";
    }
    if (!this.state.sendEmail && !this.state.sendNoteToPayee) {
      return /* @__PURE__ */ React.createElement("div", { className: "exception-sender__private-note-wrapper" }, this.privateNoteFields(), /* @__PURE__ */ React.createElement("div", { className: "small-10 column exception-sender__possible-completion-context-wrapper" }, /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          disabled: this.state.saving,
          disabledText: "Saving...",
          onClick: this.pause,
          className: "button--progress"
        },
        "Save Note"
      ), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", { className: "exception-sender__possible-completion-context" }, completionContext), this.possibleCancel())));
    }
  },
  possibleSendNoteToPayee: function() {
    if (this.state.sendNoteToPayee) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("label", null, "Message"), /* @__PURE__ */ React.createElement(
        "textarea",
        {
          rows: 12,
          maxLength: 375,
          value: this.state.body || "",
          onChange: (e) => this.setState({ body: e.target.value })
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, this.sendNoteToPayeeButton(), this.possibleCancel()), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, "(Message will also be sent via email to facilitate resolution of exceptions)"));
    }
  },
  possibleDocuments: function() {
    if (this.props.documents && this.props.documents.length > 0) {
      return /* @__PURE__ */ React.createElement("div", { className: "small-10 column exception-sender__documents-wrapper" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "" }, /* @__PURE__ */ React.createElement("span", null, "Documents to Attach"), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "v3__button-outlined v3__button-small select-all",
          onClick: () => this.toggleAllDocuments(true),
          disabled: this.allDocumentsSelected()
        },
        "Attach All"
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "v3__button-outlined v3__button-small select-all",
          onClick: () => this.toggleAllDocuments(false),
          disabled: this.noDocumentsSelected()
        },
        "Detach All"
      )), /* @__PURE__ */ React.createElement("div", { className: "exception-sender__documents" }, _.map(this.props.documents, this.showDocument)));
    }
  },
  sendButton: function() {
    var disabledText = this.state.saving ? "Sending..." : "Enter recipients to send";
    return /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        disabled: this.state.saving || !this.validEmail(),
        disabledText,
        className: "button--progress",
        onClick: this.sendMessage
      },
      "Send Message"
    );
  },
  sendNoteToPayeeButton: function() {
    var disabledText = this.state.saving ? "Sending..." : "Enter recipients to send";
    return /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        disabled: this.state.saving || !this.validPayeeMessage(),
        disabledText,
        className: "button--progress",
        onClick: this.sendNoteToPayee
      },
      "Send Message"
    );
  },
  recipientsChanged: function(recipients) {
    this.setState({
      recipients: recipients.join(", ")
    });
  },
  splitRecipients: function() {
    return this.state.recipients.split(", ");
  },
  maybeGetRecipients: function() {
    return this.showPaymentsNetworkExceptionSender() ? "" : this.splitRecipients();
  },
  noDefaultSenderEnabled: function() {
    var settings = Api.Account.currentSettings();
    return settings && settings.disable_carrier_as_default_exception_recipient;
  },
  possibleCancel: function() {
    if (this.props.canCancel) {
      return /* @__PURE__ */ React.createElement("span", { className: "button--cancel-wrapper" }, /* @__PURE__ */ React.createElement("span", { className: "button__cancel-wrapper-or" }, "or "), /* @__PURE__ */ React.createElement("button", { className: "button--cancel", onClick: this.props.cancel }, "cancel"));
    }
  },
  selectedDocumentIds: function() {
    return _.pluck(
      _.select(this.props.documents, (doc) => {
        return !this.state[doc.id];
      }),
      "id"
    );
  },
  pause: function() {
    this.setState({ saving: true });
    var promise;
    if (this.props.exceptionedItemId) {
      promise = Api.ExceptionedItems.pause(
        this.props.exceptionedItemId,
        this.state.note,
        this.state.review_on,
        this.props.emailMessageId
      );
    } else if (this.props.emailMessageId) {
      promise = Api.ExceptionedItems.pauseEmailMessage(
        this.props.emailMessageId,
        this.state.note,
        this.state.review_on
      );
    } else {
      promise = Api.ExceptionedItems.pauseDocumentGroup(
        this.props.documentGroupId,
        this.state.note,
        this.state.review_on
      );
    }
    promise.then(
      (result) => {
        this.setState({ saving: false });
        this.onComplete();
        return result;
      },
      (error) => {
        this.setState({ saving: false });
        return error;
      }
    );
  },
  onComplete: function() {
    if (this.props.toDashboardOrNextGroup) {
      this.props.toDashboardOrNextGroup();
    } else {
      this.props.onComplete();
    }
  },
  sendNoteToPayee: function() {
    this.setState({ saving: true });
    const email_id = this.props.emailMessageId || this.props.parentId || this.props.parent.id;
    Api.Email.sendRejectionNote({
      id: email_id,
      recipients: this.props.carrierInvoice.payments_network_payee_email_address,
      subject: this.state.subject,
      exceptioned_item_id: this.props.exceptionedItemId,
      document_ids: this.selectedDocumentIds(),
      document_group_id: this.props.documentGroupId,
      parent_id: this.props.parentId || this.props.parent.id,
      note: this.state.note,
      review_on: this.state.review_on,
      mark_parent_complete: this.props.markParentComplete,
      body: this.state.body
    }).then(
      (result) => {
        this.setState({ saving: false });
        this.props.onComplete();
        return result;
      },
      (error) => {
        this.setState({ saving: false });
        return Promise.reject(error);
      }
    );
  },
  sendMessage: function() {
    this.setState({ saving: true });
    Api.Email.send({
      subject: this.state.subject,
      recipients: this.allRecipients(),
      exceptioned_item_id: this.props.exceptionedItemId,
      document_ids: this.selectedDocumentIds(),
      document_group_id: this.props.documentGroupId,
      parent_id: this.props.parentId || this.props.parent.id,
      note: this.state.note,
      review_on: this.state.review_on,
      mark_parent_complete: this.props.markParentComplete,
      body: this.state.body
    }).then(
      (result) => {
        this.setState({ saving: false });
        this.props.onComplete();
        return result;
      },
      (error) => {
        this.setState({ saving: false });
        return Promise.reject(error);
      }
    );
  },
  allRecipients: function() {
    return this.state.recipients;
  },
  validEmail: function() {
    return !s.isBlank(this.allRecipients());
  },
  validPayeeMessage: function() {
    return !s.isBlank(this.state.body);
  },
  showDocument: function(document) {
    var page = _.first(document.pages);
    var classes = classNames({
      "exception-sender__document": true,
      "exception-sender__selected-document": !this.state[document.id]
    });
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classes,
        key: "document-" + document.id,
        onClick: () => {
          this.documentToggled(document);
        }
      },
      /* @__PURE__ */ React.createElement(
        DocumentThumbnail,
        {
          document,
          firstPageOnly: true,
          pageSelected: () => {
          },
          selectedPages: [page],
          hasReferenceMatch: false,
          missingReferenceMatch: false,
          isPodForLoad: false
        }
      )
    );
  },
  documentSelected: function(docId) {
    return !this.state[docId];
  },
  allDocumentsSelected: function() {
    return _.all(this.props.documents, (doc) => {
      return this.documentSelected(doc.id);
    });
  },
  noDocumentsSelected: function() {
    return _.all(this.props.documents, (doc) => {
      return !this.documentSelected(doc.id);
    });
  },
  toggleAllDocuments: function(selected) {
    var newState = {};
    _.each(this.props.documents, function(doc) {
      newState[doc.id] = !selected;
    });
    this.setState(newState);
  },
  getEmailFromTemplate: function(templateId, defaultEmail) {
    if (!this.props.multipleExceptionMessagesEnabled) {
      return defaultEmail;
    }
    const selectedTemplate = this.props.customEmailTemplates.find(
      (template) => template.id.toString() === templateId
    );
    if (selectedTemplate) {
      const email = LoadEmailCreator(
        this.props.possibleLoad,
        this.props.carrierInvoice,
        Auth._currentUser,
        selectedTemplate.subject,
        selectedTemplate.body,
        this.props.templateVariables,
        this.props.carrier
      ).initialEmail();
      return {
        selectedTemplate: selectedTemplate.id.toString(),
        subject: email.subject,
        body: email.body
      };
    } else {
      return defaultEmail;
    }
  },
  templateChanged: function(event) {
    const templateId = event.target.value;
    const email = this.getEmailFromTemplate(templateId, {
      selectedTemplate: "",
      subject: this.props.defaultEmail.subject,
      body: this.props.defaultEmail.body
    });
    this.setState(email);
  },
  renderTemplateOptions: function() {
    if (!this.props.multipleExceptionMessagesEnabled || !this.props.customEmailTemplates) {
      return null;
    }
    return this.props.customEmailTemplates.map((template) => /* @__PURE__ */ React.createElement("option", { key: template.id, value: template.id }, template.name));
  }
});
export default ExceptionSender;
